import enterpriseReportQuery from './view/enterpriseReportQuery.html'

export default {
  base: {
    state: 'declaration.corporateIncomeTax.enterpriseReportQuery',
    config: {
      url: '/enterpriseReportQuery',
      abstract: true,
      template: '<div ui-view></div>',
      default: 'declaration.corporateIncomeTax.enterpriseReportQuery.list',
      title: '申报表报表查询',
    },
  },
  list: {
    state: 'declaration.corporateIncomeTax.enterpriseReportQuery.list',
    config: {
      url: '/list',
      template: enterpriseReportQuery,
      controller: 'enterpriseReportQueryCtrl',
    },
  },
}



// WEBPACK FOOTER //
// ./src/app/declaration/corporateIncomeTax/enterpriseReportQuery/routers.js